import { useContext } from 'react';

import { toast } from 'sonner';
import { RDConnectContext } from 'src/contexts/RDConnectContext';
import { useTakeControlMutation } from 'src/redux/api/connectInstance';
import { UserVARIABLES, useGetUserVariableQuery, useSetUserVariableMutation } from 'src/redux/api/userVariable';

import { useMe } from './useMe';
import { useCamera } from 'src/contexts/hooks/useCamera';

export const useRDInstance = () => {
  const { instances, ...rest } = useContext(RDConnectContext);

  const { currentUser } = useMe();

  const [takeControl, { isLoading: isTakeControlLoading }] = useTakeControlMutation();

  const { data: rdConnectInstanceVariable } = useGetUserVariableQuery(UserVARIABLES.RD_CONNECT_INSTANCE);
  const [saveVariable, { isLoading: isSavingVariable }] = useSetUserVariableMutation();

  const userId = currentUser?.id;

  const myConnectedInstance = instances
    ? instances.find(
        (inst) => +(rdConnectInstanceVariable?.value || 0) === inst.id && inst.instance.connectedUserId === userId,
      )
    : undefined;

  const { getCameraData } = useCamera(myConnectedInstance?.id);

  const setInstance = async (id?: number | string | null) => {
    try {
      if (!id || !instances?.find((inst) => inst.id === +id)) return;

      await takeControl({ rdConnectInstanceId: +id });
      await saveVariable({ key: UserVARIABLES.RD_CONNECT_INSTANCE, value: `${id}` });
      toast.success('Connected to installation');
    } catch {
      toast.error('Failed to connect');
    }
  };

  return { instances, getCameraData, myConnectedInstance, setInstance, isSaving: isTakeControlLoading || isSavingVariable, ...rest };
};
